import type { Coordinates } from './types';
import { trpc } from '@/shared/api/trpc';

// Reverse-geocode a dragged/located map point. Proxied through `geocode.reverse`
// (Google Geocoding) so it shares the same server-side key as the search.
export const useLocationReverseGeocode = (coordinates: Coordinates | null) =>
  trpc.geocode.reverse.useQuery(
    { lat: coordinates?.lat ?? 0, lng: coordinates?.lng ?? 0 },
    { enabled: coordinates !== null, staleTime: 1000 * 60 * 5 }
  );
